import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { KTIcon } from '../../../../../../_metronic/helpers'
// UnitMeasurementModalForm
// import UnitMeasurementModalForm from '../form-edit-modal/FacilitiesModalForm'
import WCC from '../form-edit-modal/WCC'
import { KTCard } from '../../../../../../_metronic/helpers'
import SustainabilityDeclarationForm from './test'


interface ApiData {
  overallTotalDue: number
  overallTotalPaid: number
  overallTotalBalance: number
  overallTotalSupplied: number
  userRewardDetails: User[]
}

interface ApiResponse {
  data: ApiData
  meta: {
    pageSize: number
    currentPage: number
  }
  totalStock: number
}

interface User {
  userId: string
  userProfile: string
  userName: string
  totalDue: number
  totalBalance: number
  totalPaid: number
  totalSupplied: number
  transactions: any[]
}


const WasteCollectorPaymentList = () => {

  const [showAddModal, setShowAddModal] = useState(false)
  const [users, setUsers] = useState<ApiData | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [searchQuery, setSearchQuery] = useState('')
  const [filteredUsers, setFilteredUsers] = useState<User[]>([])

  const [showModal, setShowModal] = useState(false)
  const [selectedUser, setSelectedUser] = useState<User | null>(null)
  const handleEditClick = (user: User) => {
    setSelectedUser(user)
    setShowModal(true)
  }

  // Fetch data from API
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true)
        const response = await axios.get<ApiResponse>(
          `${process.env.REACT_APP_BASE_API_URL}user/due?type=66e7e51350f6c726a2bb6b55`,
          {
            headers: {
              'accept': 'application/json',
              'app-id': '3',
              'client-id': '101212',
            }
          }
        )

        const userData = response.data.data || { userRewardDetails: [] }
        setUsers(userData)
        setFilteredUsers(userData.userRewardDetails)
        setLoading(false)
      } catch (err) {
        console.error('API Error:', err)
        setError('Failed to fetch data')
        setLoading(false)
      }
    }

    fetchData()
  }, [])



  console.log("user data ...........", users)


  useEffect(() => {
    if (!users) return

    if (searchQuery === '') {
      setFilteredUsers(users.userRewardDetails)
    } else {
      const filtered = users.userRewardDetails.filter(user =>
        user.userName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        user.userId?.toLowerCase().includes(searchQuery.toLowerCase())
      )
      setFilteredUsers(filtered)
    }
  }, [searchQuery, users])

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value)
  }

  if (loading) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <div>Loading...</div>
      </div>
    )
  }

  if (error) {
    return (
      <div style={{ padding: '20px', textAlign: 'center', color: 'red' }}>
        <div>{error}</div>
      </div>
    )
  }

  return (
    <KTCard>
      <div style={{ padding: '20px' }}>
        {/* Search Box */}
        <div style={{ position: 'relative', width: '300px' }}>
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{
              position: 'absolute',
              left: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
              color: '#6B7280',
            }}
          >
            <circle cx="11" cy="11" r="8" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
          </svg>
          <input
            type="text"
            placeholder="Search users..."
            value={searchQuery}
            onChange={handleSearch}
            style={{
              width: '100%',
              height: '50px',
              padding: '8px 8px 8px 35px',
              fontSize: '14px',
              border: '1px solid #E5E7EB',
              borderRadius: '12px',
              outline: 'none',
              backgroundColor: 'white',
            }}
          />
        </div>


        {/* Metrics Cards */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '20px', padding: '20px 0px' }}>

          {/* Card 1 */}
          <div style={{ backgroundColor: '#ffffff', borderRadius: '12px', padding: '16px', display: 'flex', alignItems: 'center', gap: '16px', border: '1px solid #F0F1F3', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.02)' }}>
            <div style={{ backgroundColor: '#FFE500', width: '56px', height: '56px', borderRadius: '12px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexShrink: 0 }}>
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 7.5L12 3L21 7.5V16.5L12 21L3 16.5V7.5Z"
                  stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M3 7.5L12 12L21 7.5"
                  stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 12V21"
                  stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 5L16 9"
                  stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <div>
              <div style={{ color: '#000000', fontSize: '12px', fontWeight: '600', marginBottom: '6px' }}>Material supplied</div>
              <div style={{ color: '#000000', fontSize: '22px', fontWeight: '700', lineHeight: '1' }}>  {(users?.overallTotalSupplied || 0).toLocaleString("en", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}</div>
              <div style={{ color: '#7E8299', fontSize: '12px', marginTop: '6px' }}>All time</div>
            </div>
          </div>

          {/* Card 2 */}
          <div style={{ backgroundColor: '#ffffff', borderRadius: '12px', padding: '16px', display: 'flex', alignItems: 'center', gap: '16px', border: '1px solid #F0F1F3', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.02)' }}>
            <div style={{ backgroundColor: '#000000', width: '56px', height: '56px', borderRadius: '12px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexShrink: 0 }}>
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="9"
                  stroke="#ffffff" strokeWidth="2" />
                <path d="M14.5 8.5C14 7.8 13.2 7.5 12.2 7.5C10.9 7.5 10 8.2 10 9.2C10 10.2 10.8 10.7 12.2 11.1L13 11.3C14.4 11.7 15.2 12.2 15.2 13.3C15.2 14.5 14.1 15.3 12.6 15.3C11.4 15.3 10.3 14.8 9.7 14"
                  stroke="#ffffff" strokeWidth="2" strokeLinecap="round" />
                <path d="M12 6V18"
                  stroke="#ffffff" strokeWidth="2" strokeLinecap="round" />
              </svg>
            </div>
            <div>
              <div style={{ color: '#000000', fontSize: '12px', fontWeight: '600', marginBottom: '6px' }}>Total value</div>
              <div style={{ color: '#000000', fontSize: '22px', fontWeight: '700', lineHeight: '1' }}>   {(users?.overallTotalDue || 0).toLocaleString("en", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}</div>
              <div style={{ color: '#7E8299', fontSize: '12px', marginTop: '6px' }}>All time</div>
            </div>
          </div>

          {/* Card 3 */}
          <div style={{ backgroundColor: '#ffffff', borderRadius: '12px', padding: '16px', display: 'flex', alignItems: 'center', gap: '16px', border: '1px solid #F0F1F3', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.02)' }}>
            <div style={{ backgroundColor: '#FFE500', width: '56px', height: '56px', borderRadius: '12px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexShrink: 0 }}>
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="3" y="5" width="18" height="14" rx="2"
                  stroke="#000000" strokeWidth="2" />
                <path d="M3 9H21"
                  stroke="#000000" strokeWidth="2" strokeLinecap="round" />
                <path d="M7 14H11"
                  stroke="#000000" strokeWidth="2" strokeLinecap="round" />
                <path d="M15 14L16.5 15.5L19 12.5"
                  stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <div>
              <div style={{ color: '#000000', fontSize: '12px', fontWeight: '600', marginBottom: '6px' }}>Total payment</div>
              <div style={{ color: '#000000', fontSize: '22px', fontWeight: '700', lineHeight: '1' }}>{(users?.overallTotalPaid || 0).toLocaleString("en", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}</div>
              <div style={{ color: '#7E8299', fontSize: '12px', marginTop: '6px' }}>All time</div>
            </div>
          </div>

          {/* Card 4 */}
          <div style={{ backgroundColor: '#ffffff', borderRadius: '12px', padding: '16px', display: 'flex', alignItems: 'center', gap: '16px', border: '1px solid #F0F1F3', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.02)' }}>
            <div style={{ backgroundColor: '#000000', width: '56px', height: '56px', borderRadius: '12px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexShrink: 0 }}>
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 6.5C4 5.67 4.67 5 5.5 5H19C19.55 5 20 5.45 20 6V18C20 18.55 19.55 19 19 19H5.5C4.67 19 4 18.33 4 17.5V6.5Z"
                  stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M4 8H20"
                  stroke="#ffffff" strokeWidth="2" strokeLinecap="round" />
                <path d="M15 14H20"
                  stroke="#ffffff" strokeWidth="2" strokeLinecap="round" />
                <circle cx="15" cy="14" r="0.8" fill="#ffffff" />
              </svg>
            </div>
            <div>
              <div style={{ color: '#000000', fontSize: '12px', fontWeight: '600', marginBottom: '6px' }}>Closing balance</div>
              <div style={{ color: '#000000', fontSize: '22px', fontWeight: '700', lineHeight: '1' }}> {(users?.overallTotalBalance || 0).toLocaleString("en", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}</div>
              <div style={{ color: '#7E8299', fontSize: '12px', marginTop: '6px' }}>All time</div>
            </div>
          </div>

        </div>

        {/* Table */}
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '0' }}>
            <thead>
              <tr style={{ backgroundColor: '#000000', color: 'white' }}>
                <th style={{ padding: '15px', textAlign: 'left', fontWeight: 'bold', borderTopLeftRadius: '12px', borderBottomLeftRadius: '12px' }}>S.N</th>
                <th style={{ padding: '15px', textAlign: 'left', fontWeight: 'bold' }}>Profile</th>
                <th style={{ padding: '15px', textAlign: 'left', fontWeight: 'bold' }}>Name</th>
                {/* <th style={{ padding: '15px', textAlign: 'left', fontWeight: 'bold' }}>UNIQUE ID</th> */}
                <th style={{ padding: '15px', textAlign: 'left', fontWeight: 'bold' }}>Supplied qty</th>
                <th style={{ padding: '15px', textAlign: 'left', fontWeight: 'bold' }}>Value</th>
                <th style={{ padding: '15px', textAlign: 'left', fontWeight: 'bold' }}>Paid</th>
                <th style={{ padding: '15px', textAlign: 'left', fontWeight: 'bold' }}>Payment due</th>
                <th style={{ padding: '15px', textAlign: 'left', fontWeight: 'bold', borderTopRightRadius: '12px', borderBottomRightRadius: '12px' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {users && users.userRewardDetails.length > 0 ? (
                users.userRewardDetails.map((user, index) => (
                  <tr
                    key={user.userId}
                    style={{
                      backgroundColor: 'white'
                    }}
                  >
                    <td style={{ padding: '12px' }}>{index + 1}</td>
                    <td style={{ padding: '12px' }}>
                      {user.userProfile ? (
                        <img
                          src={user.userProfile}
                          alt="Profile"
                          style={{
                            width: '50px',
                            height: '50px',
                            borderRadius: '50%',
                            objectFit: 'cover',
                            // border: '2px solid #e2e8f0'
                          }}
                          onError={(e) => {
                            const target = e.target as HTMLImageElement
                            target.style.display = 'none'
                            // target.nextElementSibling!.style.display = 'flex'
                          }}
                        />
                      ) : null}
                      <div
                        style={{
                          width: '50px',
                          height: '50px',
                          borderRadius: '50%',
                          backgroundColor: '#333333',
                          display: user.userProfile ? 'none' : 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '15px',
                          color: '#64748b',
                          // fontWeight: 'bold'
                        }}
                      >
                        {user.userName ? user.userName.substring(0, 2).toUpperCase() : 'NA'}
                      </div>
                    </td>
                    <td style={{ padding: '12px', fontWeight: '500' }}>
                      {user.userName || 'N/A'}
                    </td>
                    {/* <td style={{ padding: '12px', fontSize: '12px', color: '#64748b' }}>
                    {user.userId?.substring(0, 8)}...
                  </td> */}
                    <td style={{ padding: '12px' }}>
                      {user.totalSupplied?.toLocaleString("en", { minimumFractionDigits: 0, maximumFractionDigits: 2 }) || '0.00'}
                    </td>
                    <td style={{ padding: '12px' }}>
                      {user.totalDue?.toLocaleString() || '0'}
                    </td>
                    <td>
                      <span style={{
                        padding: '5px',
                        fontWeight: '600',
                        color: '#17c653',
                        backgroundColor: '#dfffea',
                        borderRadius: '8px'
                      }}>
                        {user.totalPaid?.toLocaleString() || '0'}</span>
                    </td>
                    <td>
                      <span style={{
                        padding: '5px',
                        fontWeight: '600',
                        color: '#f8285a',
                        backgroundColor: '#ffeef3',
                        borderRadius: '8px'
                      }}>
                        {user.totalBalance?.toLocaleString() || '0'}</span>
                    </td>
                    <td style={{ padding: '12px' }}>
                      <div style={{ cursor: 'pointer' }} onClick={() => handleEditClick(user)}>
                        <KTIcon iconName='pencil' className='fs-3' />
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={9}
                    style={{
                      padding: '40px',
                      textAlign: 'center',
                      color: '#9ca3af',
                      fontSize: '16px'
                    }}
                  >
                    No matching records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {/* Add this before the closing </div> */}
        {/* Custom Modal */}
        {showModal && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 1000
            }}
            onClick={() => setShowModal(false)}
          >
            <div
              style={{
                backgroundColor: 'white',
                padding: '20px',
                borderRadius: '8px',
                maxWidth: '800px',
                width: '90%',
                maxHeight: '80vh',
                overflowY: 'auto'
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <h3>Edit user</h3>
                <button
                  onClick={() => setShowModal(false)}
                  style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer' }}
                >
                  ×
                </button>
              </div>

              <WCC
                isUserLoading={false}
                user={selectedUser}
                onClose={() => setShowModal(false)}
              />
            </div>
          </div>
        )}



        {/* Add New Modal */}
        {showAddModal && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 1000
            }}
            onClick={() => setShowAddModal(false)}
          >
            <div
              style={{
                backgroundColor: 'white',
                padding: '20px',
                borderRadius: '8px',
                maxWidth: '900px',
                width: '90%',
                maxHeight: '100vh',
                overflowY: 'auto'
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <h3></h3>
                <button
                  onClick={() => setShowAddModal(false)}
                  style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer' }}
                >
                  ×
                </button>
              </div>

              {/* Replace YourNewComponent with your actual component */}
              <SustainabilityDeclarationForm
                onClose={() => setShowAddModal(false)}
              />
            </div>
          </div>
        )}
      </div>
    </KTCard>
  )
}

export { WasteCollectorPaymentList }